const images = {
  login_bg: require("../assets/images/login_bg.png"),
  odf_logo: require("../assets/images/odf_logo.png"),
  odf_w_text_logo: require("../assets/images/odf_w_text_logo.jpg"),
  garuda_logo: require("../assets/images/garuda_logo.jpg"),

  // empty_image: require("../assets/images/empty_image.png"),
  // template_image: require("../assets/images/template_image.png"),
  // template_mobile_image: require("../assets/images/template_mobile_image.png"),
};
export default images;
